export default {
  BROWSER: "browser",
  BROWSER_VERSION: "browserVersion",
  OS: "os",
  RESOLUTION: "resolution",
  LANGUAGE: "language",
  TIME_ZONE: "timeZone",
  USER_AGENT: "userAgent",
};
